import React from 'react';
import PropTypes from 'prop-types';
import DeleteSignatureButton from './DeleteSignatureButton';
import UseSignatureButton from './UseSignatureButton';

const SignaturePreviewButtons = ({
  deleteSignatureOnClick,
  hasUseButton,
  type,
  useSignatureOnClick,
}) => (
  <div className="buttons signature-preview-buttons">
    <DeleteSignatureButton
      deleteSignatureOnClick={deleteSignatureOnClick}
      hasLabel={!hasUseButton}
      type={type}
    />
    { hasUseButton && <UseSignatureButton useSignatureOnClick={useSignatureOnClick} type={type} /> }
  </div>
);

SignaturePreviewButtons.defaultProps = {
  hasUseButton: false,
};

SignaturePreviewButtons.propTypes = {
  deleteSignatureOnClick: PropTypes.func.isRequired,
  hasUseButton: PropTypes.bool,
  type: PropTypes.string.isRequired,
  useSignatureOnClick: PropTypes.func.isRequired,
};

export default SignaturePreviewButtons;



// WEBPACK FOOTER //
// ./src-react/SignatureManager/components/SignaturePreviewButtons.jsx